<template>
  <div>
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Voucher
    </div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3 mt-6 class="transparent-bg">
          <h1 class="sub-title">Wprowadź kod z vouchera</h1>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="none">
              <VTextFieldWithValidation
                v-model="formData.code"
                type="text"
                :label="'Kod z vouchera'"
                placeholder="Wpisz kod z vouchera"
                rules="required"
                error="To pole nie może być puste!"
                name="code"
              />

              <button
                type="submit"
                class="primary-button mb-12"
                :loading="formData.loading"
              >
                Wykorzystaj kod
              </button>

              <div
                class=""
                style="display: flex; align-items: center; justify-content: center; flex-direction: column;"
              >
                <button
                  class="primary-button mt-12 move-button"
                  @click="moveToGiftCards"
                >
                  Kup voucher podarunkowy na subskrypcję szkoły jogi online
                </button>

                <button
                  class="primary-button mt-12 move-button"
                  @click="moveToGiftCardsForBeginners"
                >
                  Kup voucher podarunkowy na subskrypcję szkoły jogi online -
                  DagaJoga Początek
                </button>
              </div>
            </form>
          </ValidationObserver>
        </v-flex>
      </v-layout>
      <div class="text-center"></div>
    </v-container>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "../components/inputs/VTextFieldWithValidation.vue";
export default {
  metaInfo: {
    title: "Dagajoga voucher - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "GiftCardEnterCode",
  components: {
    ValidationObserver,
    VTextFieldWithValidation,
  },
  data() {
    return {
      formData: {
        code: "",
        loading: false,
      },
    };
  },
  computed: {},
  created() {
    const token = window.localStorage.getItem("userToken");
    if (!token) {
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Aby wykorzystać swój kod w pierwszej kolejności musisz zalogować się na swoje konto",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      this.$router.push({
        name: "Auth",
        params: { previousPage: "GiftCardEnterCode" },
      });
    }
  },
  destroyed() {},
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.useCode();
      this.loading = false;
    },

    async useCode() {
      return this.$store.dispatch(`giftCard/useUserGiftCard`, {
        code: this.formData.code,
      });
    },
    moveToGiftCards() {
      this.$router.push({ name: "GiftVouchers" });
    },
    moveToGiftCardsForBeginners() {
      this.$router.push({ name: "GiftVouchersForBeginners" });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Poppins:wght@300;400;600;700&family=Raleway:wght@400;500&family=Roboto:wght@300;400;500;700&display=swap");
* {
  font-family: "Inter", sans-serif;
}

.transparent-bg {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: auto;
}
i {
  font-size: 120px;
}
h1 {
  margin-bottom: 30px;
}
.center {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-top: 15px;
}
a {
  text-decoration: none;
}
form {
  display: flex;
  flex-direction: column;
}
input {
  color: black;
  width: 80%;
  margin-bottom: 30px;
  padding: 10px 0;
}
label {
  font-weight: 500;
  font-size: 1.1rem;
}
.flexit {
  display: flex;
  flex-direction: column;
}
h5 {
  background: #ce4257;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  margin-top: -25px;
  margin-bottom: 15px;
}

.background {
  color: #fff;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  width: fit-content;
  padding: 15px 25px;
  border-radius: 30px;
  font-size: 1.4rem;
}

.move-button {
  min-height: 4rem;
  width: 80%;
}

@media screen and (max-width: 600px) {
  input {
    width: 100%;
  }
  h1 {
    font-size: 1.6rem;
  }
}
</style>
